
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire887a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire887a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $762ee8b0c0ee3e4e$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["1dCiH","index.211f70a0.js","aQJn5","build.0574f9c8.js","4RVH6","signer-evm.1d7e73d4.js","2zux2","signer-evm.291c93a7.js","7Z2Gc","signer-cosmos.22dca2e6.js","bW1lK","signer-cosmos.7d381fcc.js","g0li8","signer-cosmos.61ff67f1.js","dzCCa","signer-cosmos.d278e136.js","dWYyz","signer-cosmos.dae6bc86.js","1aQKG","signer-cosmos.3770172a.js","lCI1e","Eth.ceb30550.js","hyTuH","Solana.3af82a55.js","hme7z","TransportWebHID.de81abfb.js","79XVU","ethereum.307aec27.js","87CEF","solana.3279d0ab.js","kk14V","cosmosSigner.9707a0da.js","7jnWl","utxoSigner.016e0639.js","ho2Pa","signer-sui.670e1a5d.js","3KBuu","evm.95d91664.js","63glN","ui.ed5d1f0f.js","j2HJG","ton-signer.16dc95d9.js","eAs2n","connect-web.92aad33e.js","4hEpf","ethereum.845301f0.js","2p6Un","dist.04d2ce28.js","4ubHp","evm.cce21562.js","js2w6","cosmos.aa97eab3.js","jg0Wk","solana.5bd9e23b.js"]'));


//# sourceMappingURL=index.runtime.91d2abfa.js.map
